import {
  Box,
  Container,
  Grid,
  makeStyles,
  Typography,
  Button,
  Table,
  TableRow,
  TableCell,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { backend } from "../../api";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { Link, useHistory, useParams } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  createBookOrder,
  fetchBookDetails,
} from "../../redux-store/books/actions";
import {
  RESET_BOOK,
  RESET_BOOK_ORDER,
  RESET_PROMOTED_BY,
} from "../../redux-store/constants";
import { addAmount, addAmountMem, getTax, pageCount } from "../../utils";
import { costCalculation, costCalculationDelivery } from "./LuluCalls";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    margin: "40px 0",
  },
  sectionHeading: {
    fontSize: "36px",
    fontWeight: 600,
  },
  formLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
  },
  placeSelector: {
    padding: "8px",
    width: "100%",
    borderRadius: "2px",
  },
  inputField: {
    padding: "10px",
    borderRadius: "5px",
    width: "100%",
  },
  shopBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "30px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  addressBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    // margin: "30px 0",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  radioBtns: {
    margin: "0",
    // backgroundColor:'red',
    // border: '2px solid yellow'
  },
  radioLabels: {
    fontSize: "14px",
  },
}));

const Checkout = () => {
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const { currentItem, loading, error } = useSelector((state) => state.book);
  const { order, success } = useSelector((state) => state.bookOrder);
  const { member_user } = useSelector((state) => state.adCards);
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const [billingAddress, setBillingAddress] = useState(
    currentUser?.addresses ? currentUser?.addresses[0] : "ABC"
  );
  const [amounts, setAmounts] = useState();
  const [bookPrice, setBookPrice] = useState(0);
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [taxAmount, setTaxAmount] = useState({ amount: 0, percentage: 0 });
  const [bookType, setBookType] = useState();

  useEffect(() => {
    dispatch({ type: RESET_BOOK });
    if (currentUser?.user) {
      handleFetchCurrentBook(params.bookId);
      handleFetchCurrentAmount();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentItem && amounts) {
      setDeliveryPrice(1);
      setBookType("digital_ebook");
      setBookPrice(currentItem?.price.digital_price);
      let tax = getTax(amounts, currentItem, "digital_price");
      setTaxAmount({
        percentage: amounts.tax,
        amount: tax,
      });
    }

    if (success === true) {
      dispatch({ type: RESET_BOOK_ORDER });
      dispatch({ type: RESET_PROMOTED_BY });
      history.push(`/dashboard/customer`);
    }
  }, [success, currentItem, amounts]);

  const handleRequestOrder = () => {
    let price;
    let total = +bookPrice + +taxAmount.amount + +deliveryPrice;
    price = {
      digital_price: bookPrice,
    };
    const newOrder = {
      total_price: +total,
      book_price: price,
      status: "delivered",
      source_of_approaching: "family",
      user: currentUser.user._id,
      member_id: member_user ? member_user : null,
      book: params.bookId,
      shipping_address: {
        country: billingAddress.country,
        state: billingAddress.state,
        city: billingAddress.city,
        zip: billingAddress.zip,
        name: billingAddress.name,
      },
      billing_details: {
        payment_type: "paypal",
        delivery_type: currentItem.print_on_demand,
        delivery_amount: deliveryPrice,
        tax_amount: {
          percentage: taxAmount.percentage,
          amount: taxAmount.amount,
        },
      },
    };
    dispatch(createBookOrder(newOrder));
  };
  const handleFetchCurrentBook = (id) => {
    dispatch(fetchBookDetails(id));
  };
  const handleFetchCurrentAmount = () => {
    backend.get("/amount").then((res) => {
      setAmounts(res.data.data[0]);
    });
  };
  const handleChangeValues = async (value) => {
    if (value === "digital_ebook") {
      setDeliveryPrice(1);
      setBookType(value);
      setBookPrice(currentItem?.price.digital_price);
      let tax = getTax(amounts, currentItem, "digital_price");
      setTaxAmount({
        percentage: amounts.tax,
        amount: tax,
      });
    }
  };

  return (
    <Fragment>
      <Helmet>
        <title>Checkout - d2p</title>
      </Helmet>
      <PageBanner title="Checkout" image="/assets/images/bg4.jpg" />
      <ToastContainer />
      {currentUser?.user && currentUser.user.role === "customer" ? (
        <Container>
          <h2 className={classes.sectionHeading}>Your Order</h2>
          {currentItem ? (
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={3} style={{ textAlign: "center" }}>
                <img
                  src={currentItem.book_cover}
                  style={{ maxWidth: "80%" }}
                  alt=""
                />
                <h3>{currentItem.book_title}</h3>
              </Grid>
              <Grid item xs={12} md={8} lg={9}>
                <Table>
                  <TableRow>
                    <TableCell>
                      <h4>Book Type</h4>
                      <FormControl>
                        <RadioGroup
                          value={bookType}
                          name="book type"
                          onChange={(e) => handleChangeValues(e.target.value)}
                        >
                          <FormControlLabel
                            className={classes.radioBtns}
                            value="digital_ebook"
                            checked={true}
                            control={<Radio size="small" />}
                            label={
                              <span className={classes.radioLabels}>
                                Digital eBook
                              </span>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </TableCell>
                    <TableCell>$ {bookPrice.toFixed(2)}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <h4>Tax </h4>
                    </TableCell>
                    <TableCell>$ {taxAmount.amount.toFixed(2)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <h4>Total</h4>
                    </TableCell>
                    <TableCell>
                      <h4>
                        ${" "}
                        {(
                          +deliveryPrice +
                          +bookPrice +
                          +taxAmount.amount
                        ).toFixed(2)}
                      </h4>
                    </TableCell>
                  </TableRow>
                </Table>
              </Grid>
            </Grid>
          ) : (
            <Box align="center">
              <Skeleton animaion="wave" />
            </Box>
          )}
          <div>
            <Box display="flex" alignItems="center" flexWrap="wrap">
              <h4>PayPal</h4>
              <img
                src="https://www.paypalobjects.com/webstatic/mktg/logo/AM_mc_vs_dc_ae.jpg"
                alt=""
                style={{ margin: "0 10px" }}
              />
              <h4>What is PayPal?</h4>
            </Box>
            <p>
              Pay via PayPal; you can pay with your credit card if you don’t
              have a PayPal account.
            </p>
            <p>
              Your personal data will be used to process your order, support
              your experience throughout this website, and for other purposes
              described in our privacy policy.
            </p>
            <Button
              className={classes.shopBtn}
              disabled={!bookType}
              onClick={handleRequestOrder}
            >
              Proceed to PayPal
            </Button>
          </div>
        </Container>
      ) : (
        <Container>
          <Box my={5} textAlign="center">
            <Typography
              variant="body1"
              color="error"
              style={{ fontWeight: 600, fontSize: 36, lineHeight: 1 }}
            >
              You need to Login as Customer before Checkout
            </Typography>
          </Box>
        </Container>
      )}
    </Fragment>
  );
};

export default Checkout;
